<template>
  <div class="strip-preview">
    <router-link
      :to="permalink"
      class="strip-preview__thumbnail"
    >
      <div
        class="strip-preview__img"
        :style="`background-image: url('${urlThumb}')`"
      >
      </div>
      <div class="strip-preview__overlay" v-if="!userCanRead">
        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 1110 0v4" stroke="#FFF8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
    </router-link>
    <div class="strip-preview__footer">
      <div>
        <div class="strip-preview__number">{{name}}</div>
        <div class="strip-preview__name">
          Strip {{number}}
          &middot;
          {{ publishDay }}
          <span v-if="admin">
            &middot;
            {{ isPublished ? 'Published' : 'Draft' }}
          </span>
        </div>
      </div>
      <div>
        <div class="strip-preview__tag">
          {{ free ? 'Free' : 'Paid' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { TEXTDATEFORMAT } from '@/utilities/time';

export default {
  name: 'StripPreview',
  props: {
    number: Number,
    name: String,
    caption: String,
    publishDate: Object,
    publishDay: String,
    likeCount: Number,
    url: String,
    urlThumb: String,
    free: Boolean,
    season: Object,
    payment: Object,
    userCanRead: Boolean,
    isPublished: Boolean,
    admin: Boolean,
    routeName: String,
  },
  computed: {
    publishedOn() {
      return dayjs.unix(this.publishDate.seconds).format(TEXTDATEFORMAT);
    },
    permalink() {
      return {
        name: this.routeName || 'Comic',
        params: {
          stripNumber: this.number,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.strip-preview {
  position: relative;
  margin: 30px;
  @media all and (max-width: 480px) {
    margin: 0 10px;
  }
  &__thumbnail {
    position: relative;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-large);
    background: white;
    overflow: hidden;
    margin-bottom: 10px;
    border: solid 3px transparent;
    text-decoration: none;
  }
  &__img {
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    background-size: 105% auto;
    background-repeat: no-repeat;
    background-position: 0 -12px;
    @media all and (max-width: 1150px) {
      background-size: 140% auto;
    }
    @media all and (max-width: 950px) {
      background-size: 160% auto;
    }
    @media all and (max-width: 600px) {
      background-size: 200% auto;
    }
  }
  &__number {
    font-weight: 500;
  }
  &__name {
    font-size: var(--font-small);
  }
  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__tag {
    font-size: var(--font-small);
    padding: 5px 10px;
    border-radius: 20px;
    border: solid 2px var(--color-link-inactive);
    color: var(--color-link-inactive);
    &.published {
      border-color: var(--color-dark);
      color: var(--color-dark)
    }
  }
  &__overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.7);
    color: var(--color-light);
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      margin-right: 5px;
    }
  }
}
</style>
